/**
 * Circled-ⓘ hint — the mock's inline explainer, riding the app Tooltip so
 * it portals and clamps to the viewport. Give every non-obvious label one.
 * Always a lowercase "i" — inside an uppercase label it read as a "/".
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Tooltip } from '@/components/ui/Tooltip';

interface Props {
  /** The explanation. Full sentences; this is the only documentation. */
  label: string;
  className?: string;
}

export const HintDot: FC<Props> = ({ label, className }) => (
  <Tooltip content={label} contentClassName="max-w-[300px]">
    <span
      role="img"
      aria-label={label}
      className={`inline-flex h-4 w-4 cursor-help select-none items-center justify-center rounded-full border border-border text-[10px] font-semibold normal-case italic tracking-normal text-muted-foreground ${className ?? ''}`}
    >
      i
    </span>
  </Tooltip>
);
